<template>
  <div class="container h-100">
    <el-form :model="searchCondition" inline class="form" size="mini">
      <el-form-item class="search-item">
        <CompanySelect :company-id.sync="searchCondition.company_id" placeholder="乙方名称" @change="onSubmit"
                       clearable/>
      </el-form-item>
      <el-form-item class="search-item">
        <el-input v-model="searchCondition.contract_no" placeholder="请输入合同编号" @change="onSubmit" clearable/>
      </el-form-item>
      <el-form-item>
        <select-customer :value.sync="searchCondition.customer_id" @change="onSubmit" style="width: 250px"/>
      </el-form-item>
      <el-form-item style="text-align: right" class="search-item">
        <el-button type="primary" class="el-button--operation" @click="onSubmit">查询
        </el-button>
        <el-button @click="onReset" style="margin-right:10px;">重置</el-button>
        <!--        导出组件：导出功能和历史导出记录-->
        <export-btn ref="refExportBtn" type="warning" :can-export="true" @export="exportExcel('refExportBtn')"
                    :lint-title="`导出`"></export-btn>

      </el-form-item>
    </el-form>
    <div class="default-table">
      <ApeTable ref="apeTable"
                :data="dataList"
                :columns="[]"
                :loading="loadingStatus"
                :pagingData="pagingData"
                @switchPaging="switchPaging"
                @sort-change="changeTableSort"
                highlight-current-row
                border>
        <el-table-column
            slot="first-column"
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="合同编号" prop="contract_no" min-width="120" align="center"></el-table-column>
        <el-table-column label="乙方名称" prop="company_name" min-width="100" align="center"></el-table-column>
        <el-table-column label="客户名称" prop="customer_name" min-width="220" align="center"></el-table-column>
        <el-table-column label="合同金额" prop="contract_amount" min-width="120" header-align="center"
                         align="right"></el-table-column>
        <el-table-column label="收款形式" prop="payment_method_alias" min-width="120" header-align="center"
                         align="center"></el-table-column>
        <el-table-column label="是否保量" prop="is_quantity" header-align="center"
                         align="center"
                         :min-width="100">
          <template slot-scope="{row}">{{ quantityMap[row.is_quantity] || '-' }}</template>
        </el-table-column>
        <el-table-column label="佣金比例" prop="commission_rate" header-align="center"
                         align="center"
                         :min-width="100">
          <template slot-scope="{row}"><span class="rate">{{row.commission_rate||'-'}}</span></template>
        </el-table-column>
        <el-table-column label="财务备注" prop="f_remark" min-width="200" header-align="center"
                         align="left"></el-table-column>
        <el-table-column label="合同附件" prop="annexes_count" min-width="100" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="showAnnexes(scope.row)">{{ scope.row.annexes_count }} 个文件</el-link>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="160" align="center"></el-table-column>
        <el-table-column label="修改时间" prop="updated_at" width="160" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="uploadBtn(scope.row)" v-if="userAuth.contract_upload"><i
                class="el-icon-upload"></i>上传
            </el-link>
          </template>
        </el-table-column>

      </ApeTable>
    </div>
    <!--    合同上传-->
    <UploadFile :visible.sync="dialogVisible" :current-row="currentRow" @refreshData="onSubmit"/>

    <el-dialog :title="`合同(${currentRow.contract_no})附件`" :visible.sync="dialogTableVisible">
      <ContractAnnexes ref="refContractAnnexes" :current-row="currentRow" :up-file-list="[]" :show-opt-del="false"/>
    </el-dialog>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {exportContractList, getContractList} from "@/api/adOrder";
import UploadFile from "@/views/contract/UploadFile";
import ContractAnnexes from "@/views/contract/ContractAnnexes";
import ExportBtn from "@/components/export/ExportBtn";
import CompanySelect from "@/views/adOrder/components/companySelect";
import SelectCustomer from "@/components/Selects/customer.vue";

export default {
  name: "ContractIndex",
  components: {
    SelectCustomer,
    CompanySelect,
    ExportBtn,
    ApeTable, UploadFile, ContractAnnexes
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  data() {
    return {
      loadingStatus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      dataList: [],
      columns: [
        {
          title: '编号',
          value: 'id',
          width: 100,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        }, {
          title: '合同编号',
          value: 'contract_no',
          width: 120,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        },
        {
          title: '合同金额',
          value: 'contract_amount',
          width: 120,
          header_align: 'center',
          align: 'right',
          sortable: 'custom'
        },
        {
          title: '收款形式',
          value: 'payment_method_alias',
          width: 100,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        },
        {
          title: '合同附件',
          value: 'annexes_count_alias',
          width: 80,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        },
        {title: '财务备注', value: 'f_remark', width: 220, header_align: 'center', align: 'center'},
        {
          title: '创建时间',
          value: 'created_at',
          width: 120,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        },
        {
          title: '修改时间',
          value: 'updated_at',
          width: 120,
          header_align: 'center',
          align: 'center',
          sortable: 'custom'
        },
      ],
      searchCondition: {},
      orderSort: {id: 'desc'},//默认排序规则
      dialogTableVisible: false,//合同附件查看
      dialogVisible: false,//合同上传窗口显示
      currentRow: {},//当前操作的数据
      quantityMap: {'Y': '是', 'N': '否'}
    }
  },
  methods: {
    switchPaging() {
      this.getList()
    },
    changeTableSort({prop, order}) {
      let orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.onSubmit()
    },
    async getList(type) {
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, {
        page: pagingInfo.current_page,
        per_page: pagingInfo.page_size
      }, {order: this.orderSort})
      let {list, pages} = await getContractList(searchCondition).then((res) => {
        return res.data
      })
      this.$nextTick(() => {
        this.dataList = list
      })

      this.pagingData.total = pages.total
      this.pagingData.offset = (pages.current_page - 1) * pages.page_size
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      //其他：单选字段
      let singleFields = ['contract_no', 'company_id', 'customer_id']
      singleFields.forEach((field) => {
        if (this.searchCondition[field] && this.searchCondition[field] != null) {
          condition[field] = this.searchCondition[field]
        }
      })

      return condition
    },
    onSubmit() {
      // this.$notify.success('数据请求中....')
      //mounted之后发起
      if (this.$refs['apeTable'])
        this.$refs['apeTable'].handleCurrentChange(1)
    },
    onReset() {
      this.searchCondition = {};
      this.onSubmit()
    },
    //导出
    async exportExcel(refName) {
      try {
        // this.$notify.info(refName)
        const searchCondition = this.handleSearchCondition()
        let name = '合同信息'

        const response = await exportContractList(searchCondition).then(response => {
          return response
        })

        this.$refs[refName].exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }

    },

    uploadBtn(row) {
      this.currentRow = {...row}
      this.dialogVisible = true
      //上传合同
      // console.log(row)
      // this.$notify.info(`上传合同(${ row.contract_no })资料`)
    },
    showAnnexes(row) {
      this.currentRow = {...row}
      this.dialogTableVisible = true
    },
    exportFile() {
      //
    }
  },
  mounted() {
    this.onSubmit()
  }
}
</script>

<style scoped>

</style>
